import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion as MuiAccordion, AccordionDetails as MuiAccordionDetails, AccordionSummary as MuiAccordionSummary, } from '@mui/material';
import { font } from '../../styles';
import { skipProps, styled } from '../../utils';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
function AccordionSummary({ children, endAdornment, ...props }) {
    return (_jsxs(MuiAccordionSummary, { ...props, children: [children, endAdornment && (_jsx("div", { onClick: (event) => {
                    event.stopPropagation();
                    event.preventDefault();
                }, children: endAdornment }, "endAdornment"))] }));
}
const AccordionSummaryStyled = styled(AccordionSummary, {
    shouldForwardProp: skipProps(['iconLeft']),
})(({ theme, iconLeft }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    padding: theme.spacing(0),
    minHeight: theme.spacing(6),
    '&.Mui-expanded': {
        minHeight: theme.spacing(6),
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
        color: theme.palette.primary.dark,
        marginRight: 0,
        ...(iconLeft && {
            margin: theme.spacing(0, 1),
            order: -1,
            transform: 'rotate(0deg)',
            '&.Mui-expanded': {
                transform: 'rotate(180deg)',
            },
        }),
    },
    '& .MuiAccordionSummary-content': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: font.size.m,
        '&.Mui-expanded': {
            margin: theme.spacing(1.5, 0),
        },
    },
    [theme.breakpoints.down('md')]: {
        '& .MuiAccordionSummary-content': {
            fontSize: font.size.s,
        },
    },
}));
const AccordionStyled = styled(MuiAccordion, {
    shouldForwardProp: skipProps(['showAsError']),
})(({ theme, showAsError }) => ({
    color: showAsError ? theme.palette.error.main : theme.palette.primary.dark,
    fontWeight: theme.typography.fontWeightLight,
    '&:before': {
        content: 'none',
    },
    '&.Mui-expanded': {
        margin: 0,
    },
    '&.Mui-disabled': {
        backgroundColor: 'transparent',
    },
}));
const AccordionDetailsStyled = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(0),
    margin: theme.spacing(1.5, 0),
}));
export function Accordion({ children, summary, endAdornment, square = false, iconLeft, showAsError = false, summaryVariant = 'subtitle1', ...otherProps }) {
    return (_jsxs(AccordionStyled, { showAsError: showAsError, elevation: 0, square: square, ...otherProps, children: [_jsx(AccordionSummaryStyled, { expandIcon: _jsx(Icon, { fontSize: "small", variant: "arrow-down-2" }), endAdornment: endAdornment, iconLeft: iconLeft, children: _jsx(Typography, { color: "inherit", variant: summaryVariant, children: summary }) }), _jsx(AccordionDetailsStyled, { children: children })] }));
}
